import React from 'react'
import ClassNames from 'classnames'
import { TagStyle } from './styled'
import { Image } from '../../components'
import { ICONS } from '../../themes'
import { Button } from '../Button'

/**
 * Tag description
 * - ...
 */

export class Tag extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isHoverRemoveIcon: false,
    }
  }

  handleRemoveIconHover = () => {
    this.setState(prevState => ({
      isHoverRemoveIcon: !prevState.isHoverRemoveIcon,
    }))
  }
  componentDidMount() {
    this.handleRemoveIconHover()
  }
  render() {
    const {
      className,
      removeable,
      name,
      text,
      id,
      onClick,
      onClickRemove,
    } = this.props

    const { isHoverRemoveIcon } = this.state

    return (
      <TagStyle
        className={ClassNames(
          'tag',
          { 'is-remove-hover': !isHoverRemoveIcon },
          className
        )}
        id={id}
        onClick={onClick}
        title={name || text}
      >
        <div className="text">{name || text}</div>
        {removeable && (
          <Button className="link" onClick={onClickRemove}>
            <Image
              src={ICONS['icon-remove.svg']}
              className="remove-icon"
              alt="remove icon"
              onMouseEnter={() => this.handleRemoveIconHover()}
              onMouseLeave={() => this.handleRemoveIconHover()}
            />
          </Button>
        )}
      </TagStyle>
    )
  }
}

Tag.defaultProps = {
  removeable: true,
  onClickRemove: () => {
    console.log('remove clicked')
  },
}
